import ICategory from "@/@havainnot/havainnot/interfaces/ICategory";
import { useUserCanViewNames } from "@/@havainnot/havainnot/store/selectors/appRoleSelector";
import { TFunction } from "i18next";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Header, Message } from "semantic-ui-react";
import { useApplicationConfiguration } from "../../../configuration/ConfigurationContext";
import IObservation from "../../../interfaces/IObservation";
import SchemaDisplay from "../../SchemaDisplay";
import ObservationDetail from "../ObservationDetail";
import ProcessingDetail from "../processing/ProcessingDetail";
import "./_ObservationPrint.less";

const getTextProps = (t: TFunction) => ({
    loadErrorText: t("Havainnon avaaminen epäonnistui")
});


interface ObservationPrintProps {
    observation: IObservation;
    category: ICategory
}

const ObservationPrint: React.FC<ObservationPrintProps> = ({
    observation, category
}) => {
    const params = useApplicationConfiguration()
    const texts = getTextProps(useTranslation().t);
    const { formData, formSchema } = observation;

    const canViewNames = useUserCanViewNames(category.id);

    if (!formSchema) return (
        <Message negative> {texts.loadErrorText} </Message>
    );

    const logoHref = params.siteLogoHref; // typeof params.companyPrintLogo === "undefined" ? params.siteLogoHref : params.companyPrintLogo ? params.companyPrintLogo : null
    const companyName = params.companyName; // typeof params.companyPrintName === "undefined" ? params.companyName : params.companyPrintName ? params.companyPrintName : null

    return (
        <div id="content">

            {(logoHref || companyName) ? (
                <div className="ObservationPrintHeader-container">
                    <div className="ObservationPrintHeader-logo">
                        {typeof logoHref === "string" && <img src={logoHref} className="ObservationPrintHeader-logo" />}
                    </div>
                    {companyName && <Header className="ObservationPrintHeader-title" size="huge"> {companyName} </Header>}
                </div>
            ) : null}


            <ObservationDetail observation={observation} showNameDetail={canViewNames} hiddenDivider />

            <br />

            <SchemaDisplay formSchema={formSchema} formData={{ ...formData }} canViewNames={canViewNames} />
            <ProcessingDetail observation={observation} userIsEditor={true} />


        </div>
    );
};


export default ObservationPrint;
